const openCloseGenerateGroups = (state, action) => ({
  ...state,
  generateGroupsDialogOpenFor: action.payload.generateGroupsDialogOpenFor,
});

export default openCloseGenerateGroups;
